import { createSlice } from '@reduxjs/toolkit';

import { RoleManagementState } from 'data/types';

const initialState: RoleManagementState = {
  selectedRole: [],
  selectedRoleTab: 0
};

const roleManagementSlice = createSlice({
  name: 'roleManagement',
  initialState,
  reducers: {
    setSelectedRoleTab: (state, action) => {
      state.selectedRoleTab = action.payload;
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    }
  }
});
export const { setSelectedRoleTab, setSelectedRole } = roleManagementSlice.actions;

export default roleManagementSlice.reducer;
